import { useEffect, useState } from "react";
import {
  IAddOnOption,
  IAddOnOptionMapping,
  IProductAddOn,
  IProductAddOnMapping,
} from "../../stores/products";
import { ICartItem } from "../../stores/cart";
import { currencyFormatter } from "../../utils/functions";
import defaultImgNa from "../../resources/images/img-default.jpg";
import { Modal } from "react-bootstrap";
import { observer } from "mobx-react";
import { AppConfig } from "../../AppConfig";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faMinusCircle,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

type IProductAddOns = {
  cartItem: ICartItem;
  isModalOpen: boolean;
  onModalClose: () => void;
  addProductToCart: (product: ICartItem) => void;
  isEditRequest: boolean;
  setItemQty: (qty: number) => void;
  itemQty: number;
};

const optionClass = "border label-cus-opt";

const ProductAddOns = observer(
  ({
    cartItem,
    isModalOpen,
    onModalClose,
    addProductToCart,
    isEditRequest,
    setItemQty,
    itemQty,
  }: IProductAddOns) => {
    const [visibleAccordianId, setVisibleAccordianId] = useState(1);

    useEffect(() => {
      if (!isEditRequest) {
        setItemQty(itemQty ?? 1);

        cartItem.productAddOns?.map((p) => {
          p.addOn.addOnOptions.map((o) => {
            o.addOnOption.choosen = false;
          });
        });
      } else {
        setItemQty(cartItem.Quantity ?? 1);
      }
      const acc = cartItem.productAddOns && cartItem.productAddOns[0];
      acc && setVisibleAccordianId(acc.addOnId);
    }, [cartItem, isEditRequest]);

    const handleSetItemQty = (qty: number) => {
      setItemQty(qty);
      if (isEditRequest) cartItem.Quantity = qty;
    };

    const onCheck = (
      opt: IAddOnOption,
      checked: boolean,
      addOn: IProductAddOn
    ) => {
      if (!cartItem.addOnsPrice) cartItem.addOnsPrice = 0;
      if (addOn) {
        const currentCheckedOpt = addOn.canChooseMultiple
          ? null
          : addOn.addOnOptions.find((p) => p.addOnOption.choosen === true);
        if (currentCheckedOpt) {
          currentCheckedOpt.addOnOption.choosen = false;
          cartItem.addOnsPrice -=
            currentCheckedOpt.addOnOption.addOnOptionPrice;
        }
      }

      if (checked) {
        cartItem.addOnsPrice += opt.addOnOptionPrice;
      } else cartItem.addOnsPrice -= opt.addOnOptionPrice;

      opt.choosen = checked;
    };

    const handleOnClose = () => {
      if (!isEditRequest) setItemQty(1);
      onModalClose();
    };

    const itemTotal = currencyFormatter(
      cartItem.sellPrice + (cartItem.addOnsPrice ?? 0)
    );

    return (
      <Modal
        show={isModalOpen}
        onHide={() => handleOnClose()}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>{cartItem.productName}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <img
              src={
                cartItem?.productImagePath
                  ? `${AppConfig.APIBaseUrl}${cartItem.productImagePath}`
                  : defaultImgNa
              }
              alt="Product"
              className="w-100 object-cover mb-2"
              height={250}
            />

            <p className="mb-2 small">{cartItem.description}</p>
            <h5 className="text-lg font-semibold mb-1">{itemTotal}</h5>

            {cartItem.productAddOns?.map(
              ({ addOn }: IProductAddOnMapping, i) => {
                return (
                  <div className="mb-2" key={"map_" + i}>
                    <div
                      className="cursor-pointer d-flex align-items-center justify-content-between bg-light p-2 mt-3"
                      onClick={() =>
                        setVisibleAccordianId(
                          visibleAccordianId != addOn.addOnId
                            ? addOn.addOnId
                            : 0
                        )
                      }
                    >
                      <h5 className="text-md font-semibold">
                        {addOn.addOnName}
                      </h5>

                      <FontAwesomeIcon
                        icon={
                          visibleAccordianId === addOn.addOnId
                            ? faChevronUp
                            : faChevronDown
                        }
                      />
                    </div>
                    <div
                      className="overflow-hidden transition-height duration-300 ease-in-out"
                      style={{
                        height:
                          visibleAccordianId === addOn.addOnId ? "auto" : "0px",
                      }}
                    >
                      <div className="">
                        {addOn.addOnOptions.map(
                          ({ addOnOption }: IAddOnOptionMapping, i) => {
                            const id = `opt_${addOn.addOnId}_${addOnOption.addOnOptionId}`;
                            return (
                              <div key={"opt_" + i} className="p-1">
                                <input
                                  type={
                                    addOn.canChooseMultiple
                                      ? "checkbox"
                                      : "radio"
                                  }
                                  className="btn-check"
                                  name={`opts_${addOn.addOnId}`}
                                  id={id}
                                  autoComplete="off"
                                  onChange={(e) =>
                                    onCheck(
                                      addOnOption,
                                      e.target.checked,
                                      addOn
                                    )
                                  }
                                  checked={addOnOption.choosen === true}
                                />
                                <label
                                  className={`btn d-flex justify-content-between ${optionClass}`}
                                  htmlFor={id}
                                >
                                  <span>{addOnOption.addOnOptionName}</span>
                                  <span>
                                    {currencyFormatter(
                                      addOnOption.addOnOptionPrice
                                    )}
                                  </span>
                                </label>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-between pb-1">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon
              icon={faMinusCircle}
              className="fs-1 text-danger cursor-pointer"
              onClick={() => handleSetItemQty(itemQty > 1 ? itemQty - 1 : 1)}
            />
            <span className="p-2 fs-4">{itemQty}</span>
            <FontAwesomeIcon
              icon={faPlusCircle}
              className="fs-1 text-success cursor-pointer"
              onClick={() => handleSetItemQty(itemQty + 1)}
            />
          </div>
          <button
            className="btn btn-default d-flex flex-fill justify-content-between"
            onClick={() =>
              isEditRequest ? handleOnClose() : addProductToCart(cartItem)
            }
          >
            {isEditRequest ? (
              <span>
                <FontAwesomeIcon icon={faCheckCircle} className="me-2" />
                Update
              </span>
            ) : (
              <span>
                <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                Add to Cart
              </span>
            )}
            <span>{itemTotal}</span>
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
);

export default ProductAddOns;
